function numberReg(value) {
    let reg = /^-?\d+(\.\d+)?$/; // 正则表达式 只能输入小数 包含小数点
    if (reg.test(value)) {
      return true;
    } else {
      return false;
    }
}

export default numberReg;